import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaYoutube } from 'react-icons/fa';
import { FiArrowUpRight } from 'react-icons/fi';
import turboSquidLogo from './turbosquid-logo.svg';
import cgTraderLogo from './cgtrader-logo.svg';

const LINK = 'text-white/55 text-[11.5px] tracking-wider uppercase hover:text-white transition-colors';
const SOCIAL = 'text-white/55 hover:text-white transition-colors inline-flex items-center gap-1.5 text-[11.5px]';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      className="bg-[#0B0B0B] border-t border-white/[0.07] py-10"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3, ease: [0.32, 0.72, 0, 1] }}
    >
      {/* Same container token as the nav and every content section */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          <div>
            <Link to="/" className="font-display text-[13px] font-extrabold tracking-[0.2em] text-white/85 hover:text-white transition-colors">
              GIANLUCA GATTO
            </Link>
            <p className="text-white/55 text-[12.5px] mt-2">3D environments &amp; game-ready props</p>
          </div>

          <div className="flex flex-wrap gap-x-7 gap-y-2">
            {[
              { path: '/', label: 'Work' },
              { path: '/services/', label: 'Services' },
              { path: '/videos/', label: 'Videos' },
              { path: '/blog/', label: 'Blog' },
              { path: '/about/', label: 'About' },
              { path: '/contact/', label: 'Contact' },
            ].map(({ path, label }) => (
              <Link key={path} to={path} className={LINK}>{label}</Link>
            ))}
          </div>

          <div className="flex flex-wrap gap-4">
            <a
              href="https://www.turbosquid.com/Search/Artists/GianlucaGatto"
              target="_blank" rel="noopener noreferrer" aria-label="TurboSquid" className={`${SOCIAL} group`}
            >
              <img src={turboSquidLogo} alt="" aria-hidden="true" className="h-3.5 opacity-40 group-hover:opacity-80 transition-opacity" style={{ filter: 'brightness(0) invert(1)' }} />
              TurboSquid
              <FiArrowUpRight size={10} />
            </a>
            <a
              href="https://www.cgtrader.com/designers/gianluca-gatto"
              target="_blank" rel="noopener noreferrer" aria-label="CGTrader" className={`${SOCIAL} group`}
            >
              <img src={cgTraderLogo} alt="" aria-hidden="true" className="h-3.5 opacity-40 group-hover:opacity-80 transition-opacity" style={{ filter: 'brightness(0) invert(1)' }} />
              CGTrader
              <FiArrowUpRight size={10} />
            </a>
            <a
              href="https://sketchfab.com/shockproof"
              target="_blank" rel="noopener noreferrer" aria-label="Sketchfab" className={SOCIAL}
            >
              Sketchfab
              <FiArrowUpRight size={10} />
            </a>
            <a
              href="https://www.youtube.com/@Gianluca3D"
              target="_blank" rel="noopener noreferrer" aria-label="YouTube" className={SOCIAL}
            >
              <FaYoutube size={14} />
              YouTube
              <FiArrowUpRight size={10} />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/[0.07]">
          <p className="text-white/45 text-[11.5px]">&copy; {currentYear} Gianluca Gatto</p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
